/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAIcon16Light = forwardRef('MediaAudioVolumeAIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.498 1.23A.9.9 0 0 1 12 1.897v12.204a.9.9 0 0 1-1.502.669L6.308 11H3.5A1.5 1.5 0 0 1 2 9.5v-3A1.5 1.5 0 0 1 3.5 5h2.808l4.19-3.77Zm.502.893-4.023 3.62A1 1 0 0 1 6.308 6H3.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h2.808a1 1 0 0 1 .67.257L11 13.877V2.123Z" })));
});
